const travelPalette = {
  baggageOfferHeader: '#D6ECF6',
  pageBackground: {
    end: '#EAF3F8',
    start: '#F5FAFC',
  },
  policyPending: {
    background: '#EAF3F9',
    border: '#C9E0EE',
    title: '#1F4E79',
  },
};

export const extendTravelTheme = outerTheme => ({
  ...outerTheme,
  palette: {
    ...outerTheme.palette,
    travel: travelPalette,
  },
});